import { render, staticRenderFns } from "./BaseButtonDanger.vue?vue&type=template&id=a38d4c20&"
import script from "./BaseButtonDanger.vue?vue&type=script&lang=js&"
export * from "./BaseButtonDanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports